module.exports = __webpack_public_path__ + "img/logo-purelife.2d0317fa.jpg";